<template>
  <!-- <el-drawer class="patient-tags" title="标签" :visible.sync="visible" :before-close="handleClose"> -->
  <div class="tags-content">
    <div class="tags-item">
      <div class="title">
        <p></p>
        <span>系统标签</span>
        <span class="edit-icon" @click="editLabel"></span>
      </div>
      <div class="content">
        <span class="tag" v-for="(item, key) in patientLabelObj.definedLabelList" :key="key">{{ item.labelName }}</span>
      </div>
    </div>
    <div class="tags-item" v-if="patientLabelObj.dcLabelList && patientLabelObj.dcLabelList.length > 0">
      <div class="title">
        <p></p>
        <span>DC系统标签</span>
      </div>
      <div class="content">
        <span class="tag dc" v-for="(item, key) in patientLabelObj.dcLabelList" :key="key">{{ item.labelName }}</span>
      </div>
    </div>
    <div class="tags-item" v-if="patientLabelObj.workWechatLabelList && patientLabelObj.workWechatLabelList.length > 0">
      <div class="title">
        <p></p>
        <span>企微标签</span>
      </div>
      <div class="content">
        <span class="tag qw" v-for="(item, key) in patientLabelObj.workWechatLabelList"
          :key="key">{{ item.labelName }}</span>
      </div>
    </div>
    <span class="load-end">已加载完全部标签</span>
    <!-- 编辑标签 -->
    <el-dialog :visible.sync="dialogVisible" width="30%" append-to-body class="patient-dialog">
      <div class="title">患者专属标签编辑</div>
      <div class="title-item">每个患者最多添加100个标签奥～</div>
      <div class="label">
        <ul>
          <li v-for="(item,index) in labelArr" :key="index" :style="{ background : item.colour }">
            {{ item.labelName ? item.labelName : item.name  }}
            <span style="color:#fff;font-size:14px;cursor: pointer;margin-left:5px" class="el-icon-circle-close"
              @click="deleteLable(item,index)"></span>
          </li>
        </ul>
      </div>
      <div class="label-search" v-if="addSearch">
        <div class="search-title">每个患者最多添加100个标签奥～</div>
        <div class="search-form">
          <el-select value-key='id' v-model="searchValue" filterable remote reserve-keyword size="mini"
            placeholder="请输入你要搜索的内容" @change="selectOneChange" :remote-method="remoteMethod">
            <el-option v-for="item in labelClass" :key="item.value" :label="item.name" :value="item"></el-option>
          </el-select>
          <el-select style="width:29%" size='mini' v-model="value" placeholder="请选择标签类别" @change="labelChange">
            <el-option v-for="(item,index) in leftInfo" :key="index" :label="item.type" :value="item.id"></el-option>
          </el-select>
          <el-select style="width:29%" size='mini' v-model="value1" value-key='id' placeholder="请选择标签"
            @change="pushLabelId">
            <el-option v-for="(item,index) in rightInfo" :key="index" :label="item.name" :value="item"></el-option>
          </el-select>
        </div>
      </div>
      <div class="add-label" @click="addSearch = true;addLabelModel=false" v-if="addLabelModel">
        <div>+添加一个标签</div>
      </div>
      <div class="updata-btn" slot="footer">
        <el-button size="mini" style="width:110px;height:32px;" @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" size="mini" style="width:110px;height:32px;" @click="updateForm">保存</el-button>
      </div>
    </el-dialog>
  </div>
  <!-- </el-drawer> -->
</template>

<script>
import {
  apiLabel_leftData,
  apiLabel_leftData_page,
  apiLabel_InsertPatientLabel
} from "../../SystemSettings/LabelManage/api/index";
export default {
  data() {
    return {
      dialogVisible: false,
      addSearch: false,
      labelArr: [],
      addLabelModel: true,
      labelClass: [],
      rightInfo: []
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    patientLabelObj: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    handleClose() {
      this.$emit("updatePatientTagVisible", false);
    },
    //远程搜索
    remoteMethod(val) {
      apiLabel_leftData_page({
        redundant: val,
        current: 1,
        size: 99
      }).then(res => {
        this.labelClass = res.data.records;
      });
    },
    //下拉框change 事件
    labelChange(val) {
      apiLabel_leftData({
        parentId: val
      }).then(res => {
        this.rightInfo = res.data;
      });
    },
    editLabel() {
      this.searchValue = "";
      this.value = "";
      this.value1 = "";
      this.labelArr = [];
      if (this.patientLabelObj.definedLabelList) {
        this.patientLabelObj.definedLabelList.forEach(item => {
          this.labelArr.push(item);
        });
      }
      this.addSearch = false;
      this.dialogVisible = true;
      this.addLabelModel = true;
      apiLabel_leftData({
        parentId: 0
      }).then(res => {
        this.leftInfo = res.data;
      });
    },
    pushLabelId(val) {
      if (this.labelArr.length >= 100) {
        this.$message.error("每个患者最多添加100个标签奥～");
        this.value1 = null;
      } else {
        this.labelArr.push(val);
      }
    },
    selectOneChange(val) {
      let flag = false;
      this.labelArr.forEach((item, index) => {
        if (item.labelName == val.name) {
          flag = true;
        }
      });
      console.log(flag, "flag");
      if (this.labelArr.length >= 100) {
        this.searchValue = null;
        this.$message.error("每个患者最多添加100个标签奥～");
        return false;
      } else if (flag) {
        this.$message.error("已经选择过相同的标签，请重新选择");
        this.searchValue = null;
        return false;
      } else {
        this.labelArr.push(val);
      }
    },
    //删除标签
    deleteLable(item, index) {
      if (item.source == 2) {
        this.$confirm("请确认，是否对当前标签进行删除", "该标签为医生添加", {
          distinguishCancelAndClose: true,
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          customClass: "message-confirm-style"
        }).then(() => {
          this.labelArr.splice(index, 1);
        });
      } else {
        this.$confirm("请确认，是否对当前标签进行删除", "确认信息", {
          distinguishCancelAndClose: true,
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          customClass: "message-confirm-style"
        }).then(() => {
          this.labelArr.splice(index, 1);
        });
      }
    },
    //保存按钮
    updateForm() {
      if (this.labelArr.length > 100) {
        this.dialogVisible = false;
        this.$message.error("每个患者最多添加100个标签奥～");
        return false;
      }
      let upArr = [];
      this.labelArr.forEach(item => {
        if (item.labelId) {
          upArr.push(item.labelId);
        } else {
          upArr.push(item.id);
        }
      });
      let workWechatLabelList = this.patientLabelObj.workWechatLabelList.map(
        item => item.labelId
      );
      upArr = [...upArr, ...workWechatLabelList];
      apiLabel_InsertPatientLabel({
        labelId: upArr,
        wholeCourseId: this.patientLabelObj.wholeCourseId,
        patientId: this.patientLabelObj.patientId
      }).then(res => {
        if (res.code == 0) {
          this.$message({
            message: "成功",
            type: "success"
          });
          this.dialogVisible = false;
          // 告知父组件调用详情接口
          this.$emit("upPatientTag");
        } else {
          this.$message.error(res.message);
        }
      });
    }
  }
};
</script>

<style lang="less">
.tags-content {
  padding: 24px 24px;
  .load-end {
    display: flex;
    justify-content: center;
    font-size: 12px;
    color: #999999;
    line-height: 36px;
    margin-top: 30px;
  }
  .tags-item {
    margin-bottom: 30px;
    .title {
      display: flex;
      align-items: center;
      p {
        width: 4px;
        height: 15px;
        background: #1a7bfc;
        margin-right: 12px;
      }
      span {
        font-size: 14px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        line-height: 22px;
      }
      .edit-icon {
        width: 30px;
        height: 30px;
        background: url(../../../assets/images/edit_icon.png) no-repeat;
        background-size: contain;
        margin-left: 12px;
        cursor: pointer;
      }
    }
    .content {
      display: flex;
      flex-wrap: wrap;
      .tag {
        padding: 5px 8px;
        border-radius: 2px;
        background: #f0f5ff;
        font-weight: 500;
        font-size: 12px;
        color: #333333;
        line-height: 12px;
        margin: 12px;
        margin-bottom: 0;
        &.dc {
          background: #eaf8fe;
        }
        &.qw {
          background: #ecfff4;
        }
      }
    }
  }
}
.patient-dialog {
  .title {
    font-size: 18px;
    font-weight: bolder;
    text-align: center;
    color: #000;
    margin-bottom: 10px;
  }
  .title-item {
    font-size: 12px;
    text-align: center;
  }
  .label {
    height: 450px;
    overflow-y: auto;
    margin-top: 20px;
    ul {
      display: flex;
      flex-wrap: wrap;
      border-bottom: 1px solid #f0f0f0;
      margin-bottom: 20px;
      li {
        padding: 0 7px;
        line-height: 22px;
        min-width: 54px;
        text-align: center;
        background: #0d5fca;
        border-radius: 12px;
        border: 1px solid #e9f2ff;
        color: #1a7bfc;
        font-size: 10px;
        margin-right: 10px;
        color: #fff;
        margin-bottom: 20px;
      }
      li:last-child {
        margin-right: 0;
        margin-bottom: 20px;
      }
    }
  }
  .label::-webkit-scrollbar {
    width: 5px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 90px;
  }

  .label::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
    background: rgba(0, 0, 0, 0.2);
  }

  .label::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px #ebeef5;
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }
  .label-search {
    .search-title {
      color: #666666;
      font-size: 12px;
      margin-bottom: 20px;
      margin-top: 20px;
    }
    .search-form {
      display: flex;
      justify-content: space-between;
    }
  }
  .add-label {
    margin-top: 30px;
    font-size: 12px;
    color: #ccc;
    width: 100%;
    height: 35px;
    border: 1px dashed #ccc;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    &:hover {
      border: 1px dashed #1a7bfc;
      color: #1a7bfc;
    }
  }
  .updata-btn {
    text-align: center;
    margin-top: 30px;
  }
}
</style>